<template>
  <div class="control">
    <flatpicker-component
      ref="flatpicker"
      :placeholder="'Pick date range'"
      :config="config"
      :selectedDates="selectedDates"
      @onDateSelected="$emit('onDateSelected', $event)">
    </flatpicker-component>
    <div class="is-pulled-right margin-top">
      <button
        class="button is-success is-outlined"
        @click="clearData"
        v-translate>
        Reset
      </button>
    </div>
  </div>
</template>
<script>
  import FlatpickerComponent from '@/components/layout/utility/FlatpickerComponent'

  export default {
    name: 'date-picker-component',
    components: {
      FlatpickerComponent
    },
    props: {
      selectedDates: {
        type: Array,
        default: () => []
      },
      config: {
        type: Object,
        default: () => ({ dateFormat: 'Y-m-d', static: false })
      }
    },
    methods: {
      clearData (event) {
        this.$emit('onDateCleared', event)
        this.$refs.flatpicker.flatpicker.clear()
      }
    }
  }
</script>
<style lang="sass" scoped>
  .margin-top
    margin-top: 1rem
</style>
